import "./TH.css";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CourseMasterData from "./CourseMasterData";
import THTrainingList from "./THTrainingList";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import THManageNomination from "./THManageNomination";
import { styled } from "@mui/material/styles";
import UploadAbacus from "./UploadAbacus";
import { useTabContext } from "../../../TabContext";
import THUserContent from "../../../function-components/newUserMaintenance/THUserContent";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const theme = createTheme({
  typography: {
    fontFamily: "Graphik-Regular",
  },
});
const AntTabs = styled(Tabs)({
  borderBottom: "1px solid #e8e8e8",
  "& .MuiTabs-indicator": {
    visibility: "hidden",
  },
});
const AntTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    minWidth: 0,
    [theme.breakpoints.up("sm")]: {
      minWidth: 0,
    },
    marginRight: theme.spacing(1),
    color: "#A6A6A6",
    fontFamily: "graphik-regular",
    fontWeight: "bold",
    border: "solid 1px #A6A6A6 ",
    borderBottom: "0px",
    "&.Mui-selected": {
      color: "white",
      //   fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: "#550A69",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#d1eaff",
    },
  })
);

const THContent = () => {
  const { activeTab, setActiveTab } = useTabContext();
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  return (
    <ThemeProvider theme={theme}>
      <div className="banner training-banner-box">
        <img
          src={process.env.PUBLIC_URL + "/images/Home/training-banner.png"}
          alt="banner"
          className="home-banner"
        />
        <h1 className="banner-content">Training Host View</h1>
      </div>
      <div className="main-container-th">
        <Box className="boxStyles-th">
          <Box sx={{ borderColor: "divider" }} className="tabMenuWrap-th">
            <AntTabs
              value={activeTab}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              <AntTab
                sx={{
                  borderRight: "0px",
                  marginRight: "0px",
                  borderTopLeftRadius: "5px",
                }}
                label="Manage Course Master"
                key="tab0"
                {...a11yProps(0)}
                className="tabStyles-th"
              />
              <AntTab
                sx={{
                  borderRight: "0px",
                  borderLeft: "0px",
                  marginRight: "0px",
                }}
                key="tab1"
                label="Training Sessions"
                {...a11yProps(1)}
                className="tabStyles-th"
              />

              <AntTab
                sx={{
                  borderLeft: "0px",
                  marginRight: "0px",
                  borderRight: "0px",
                }}
                key="tab2"
                label="Manage Nomination"
                {...a11yProps(2)}
                className="tabStyles-th"
              />
              <AntTab
                sx={{
                  borderLeft: "0px",
                  marginRight: "0px",
                  borderRight: "0px",
                }}
                key="tab4"
                label="Upload Abacus Data"
                {...a11yProps(3)}
                className="tabStyles-th"
              />
              {/* <AntTab
                sx={{
                  borderLeft: "0px",
                  marginRight: "0px",
                  borderRight: "0px",
                }}
                key="tab4"
                label="Settings"
                {...a11yProps(4)}
                className="tabStyles-th"
              /> */}
              <AntTab
                sx={{
                  borderLeft: "0px",
                  marginRight: "0px",
                  borderTopRightRadius: "5px",
                }}
                key="tab4"
                label="User Maintenance"
                {...a11yProps(4)}
                className="tabStyles-th"
              />
            </AntTabs>
          </Box>
          <TabPanel className="tabPanelWrap-th" value={activeTab} index={0}>
            <CourseMasterData/>
          </TabPanel>
          <TabPanel className="tabPanelWrap-th" value={activeTab} index={1}>
            <THTrainingList/>
          </TabPanel>
          <TabPanel className="tabPanelWrap-th" value={activeTab} index={2}>
            <THManageNomination />
          </TabPanel>
          <TabPanel className="tabPanelWrap-th" value={activeTab} index={3}>
            <UploadAbacus />
          </TabPanel>
          {/* <TabPanel className="tabPanelWrap-th" value={activeTab} index={4}>
            <ManageAccess />
          </TabPanel> */}
          <TabPanel className="tabPanelWrap-th" value={activeTab} index={4}>
            {/* <ManageAccess /> */}
            <THUserContent trackId={1}/>
          </TabPanel>
        </Box>
      </div>
    </ThemeProvider>
  );
};

export default THContent;
